import React from 'react';
// import { Link } from 'react-router-dom';
// import logout from '../Components/Image/logout.png'
// import Sidebar from '../Components/Sidebar';
// import { Button } from 'react-bootstrap';
// import Table from '../Components/ReusableTable'
import DropdownFlat from '../Components/DropdownFlat'
import Select from "react-select"
// import ScrollToTop from "../Components/ScrollToTop"
// import Carousel from '../Components/Carousel.js';
import { connect } from 'react-redux'
import { getSupplierPOs } from '../store/actions/supplierActions'
import { postRequestInspection, getVendorPODetailsWithStages, posNewtRequestInspection } from '../store/actions/vendorActions'
// import SearchBar from '../Components/SearchBar';
// import MultiSelect from "react-multi-select-component";
import { Form } from "react-bootstrap"
import AuthHandlerInstance from '../Classes/AuthHandler'
import swal from '@sweetalert/with-react'

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isRequestingInspection: false,
            QAPlanningtabledata: [{ "ponumber": "123", "vendor": "ABC", "createdOn": "12/12/12", "poamount": "1234", "location": "location1" },
            { "ponumber": "123", "vendor": "ABC", "createdOn": "12/12/12", "poamount": "1234", "location": "location2" },
            { "ponumber": "123", "vendor": "ABC", "createdOn": "12/12/12", "poamount": "1234", "location": "location3" }
            ],
            supplierName: "",
            selectedFromDropdown: "",
            selected: [],
            selectedInspections: [],
            formattedData: [],
            checked: [],
            callItems: [
                {
                    PurchaseOrderId: '',
                    PurchaseOrderItem: '',
                    PurchaseOrderList: [],
                    PurchaseOrderLineList: [],
                    PurchaseOrderLineId: '',
                    stagesList: [],
                    stages: [],
                    finalLineItemsList: [],
                    finalLineItems: [],
                    checkedAll: false,
                    inspectionTypes: [
                        {
                            id: 0, name: "Stage",
                        },
                        {
                            id: 1, name: "Final",
                        },
                    ],
                    inspectionType: 0,
                }
            ],
            vendorProposedDate: '',
            location: '',
            array: [
                { value: 1, label: "element1" },
                { value: 2, label: "element2" },
                { value: 3, label: "element3" },
                { value: 4, label: "element4" }
            ],
            inspectionTypes: [
                {
                    value: 0, label: "Stage",
                },
                {
                    value: 1, label: "Final",
                },
            ],
            inspectionType: 0,
        }

        // this.validateInput = this.validateInput.bind(this);
        // this.handleChange = this.handleChange.bind(this);
        // this.togglebutton = this.togglebutton.bind(this);
        // this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this)
    }

    componentDidMount() {
        this.storeData()

        // ? shows pos of vendor
        console.log(this.props.vendorPOsWithStages.vendorPOsWithStages)

    }

    storeData = async () => {

        await this.props.getVendorPODetailsWithStages(AuthHandlerInstance.getUserPayLoad().userId)
        if (this.props.vendorPOsWithStages && this.props.vendorPOsWithStages.vendorPOsWithStages && this.props.vendorPOsWithStages.vendorPOsWithStages.polineItems) {
            this.formatData(this.props.vendorPOsWithStages.vendorPOsWithStages.polineItems)
        }

    }

    // ? func to add inspection quantity
    handleIQuantityInput = (e, itemIndex, rowIndex, totalquantity, unit = '', inspectionType = '') => {

        let callItems = [...this.state.callItems]

        if (e.target.value > totalquantity) {
            let errorMessage = `Offered Quantity (${e.target.value + " " + unit}) is greater than Pending Quantity(${totalquantity + " " + unit}). Please revise it again`
            swal(errorMessage, { icon: "error" })
            if (inspectionType !== '') {
                callItems[itemIndex].finalLineItemsList[rowIndex].offeredQuantity = 0
            } else {
                callItems[itemIndex].stagesList[rowIndex].offeredQuantity = 0
            }
        }

        else {
            if (inspectionType !== '') {
                callItems[itemIndex].finalLineItemsList[rowIndex].offeredQuantity = e.target.value
            } else {
                callItems[itemIndex].stagesList[rowIndex].offeredQuantity = e.target.value
            }
        }
        // ? check whether formattedData is getting updated
        // console.log("formatted Data : Quan", formattedData)
        this.setState({
            callItems
        })

    }

    handleDate = (e) => {

        const selectedDate = new Date(e.target.value);

        const currentDate = new Date();

        let curDate = currentDate.toISOString().split("T")[0]

        console.log("KJHGFCXVBW NDS", curDate)



        this.setState({ vendorProposedDate: e.target.value });



    };
    checkInspectionDate = (e) => {

        console.log("oiuygfvbnmsd", e.target.value)

        const selectedDate = new Date(e.target.value);

        const currentDate = new Date();

        let curDate = currentDate.toISOString().split("T")[0]

        console.log("KJHGFCXVBW NDS", curDate)

        if (selectedDate.setHours(0, 0, 0, 0) < currentDate.setHours(0, 0, 0, 0)) {

            swal("Please select a date on or after the current date.", { icon: "error" });

            e.target.value = currentDate.toISOString().split("T")[0];

            console.log(curDate)

            this.setState({ vendorProposedDate: curDate });

        }

    };

    handleLocation = (e) => {
        let location = e.target.value

        this.setState({ location })
    }

    handlePoChange = (e, index) => {
        let callItems = [...this.state.callItems]
        callItems[index].finalLineItemsList = [];
        callItems[index].stagesList = [];
        // let exist = callItems.find((item, i) => i !== index && item.PurchaseOrderId === e.target.value)
        // if (exist) {
        //     callItems[index].PurchaseOrderId = ''
        //     callItems[index].PurchaseOrderLineList = []
        //     this.setState({ callItems: callItems })
        //     swal('The same Po is already selected', { icon: "error" })
        //     return false;
        // }
        console.log(this.props.vendorPOsWithStages.vendorPOsWithStages.polineItems)
        callItems[index].PurchaseOrderId = e.value
        callItems[index].PurchaseOrderItem = e
        callItems[index].PurchaseOrderLineList = []

        this.props.vendorPOsWithStages.vendorPOsWithStages.polineItems.map((element, Index) => {
            console.log(element.QATemplateStageCompleted, element.POSAPId, 'element.QATemplateStageCompleted')
            if (callItems[index].PurchaseOrderId === element.POSAPId) {
                if (parseInt(callItems[index].inspectionType) === 1) {
                    for (let i = 0; i < element.finalItems.length; i++) {
                        const elem = element.finalItems[i];
                        callItems[index].finalLineItemsList.push(
                            {
                                id: elem.PurchaseOrderLineId,
                                POLineItemSAPCode: elem.POLineItemSAPCode,
                                totalQuantity: elem.CallItemType !== null ? elem.TotalQuantity : elem.POLineItemQuantity,
                                pendingQuantity: elem.CallItemType !== null ? elem.TotalQuantity - elem.OfferedQuantity : elem.POLineItemQuantity - elem.OfferedQuantity,
                                offeredQuantity: 0,
                                prevOfferedQuantity: elem.OfferedQuantity,
                                AcceptedQuantity: elem.AcceptedQuantity,
                                acceptQty: elem.CallItemType !== null ? elem.RWAcceptedQuantity === null || elem.RWAcceptedQuantity === null ? 0 : elem.RWAcceptedQuantity : elem.AcceptedQuantity === null || elem.AcceptedQuantity === '' ? 0 : elem.AcceptedQuantity,
                                CallItemType: elem.CallItemType,
                                // CallID: elem.CallID,
                                // IsActive: elem.IsActive,
                                InspectionCallItemId: elem.InspectionCallItemId,
                                ParentCallId: elem.CallItemType !== null ? elem.InspectionCallItemId : elem.ParentCallId,
                            }
                        )
                    }
                } else {
                    for (let i = 0; i < element.stageItems.length; i++) {
                        const elem = element.stageItems[i];
                        callItems[index].stagesList.push(
                            {
                                id: elem.PurchaseOrderLineId,
                                POLineItemSAPCode: elem.POLineItemSAPCode,
                                totalQuantity: elem.CallItemType !== null ? elem.TotalQuantity : elem.POLineItemQuantity,
                                pendingQuantity: elem.CallItemType !== null ? elem.TotalQuantity - elem.OfferedQuantity : elem.POLineItemQuantity - elem.OfferedQuantity,
                                offeredQuantity: 0,
                                prevOfferedQuantity: elem.OfferedQuantity,
                                AcceptedQuantity: elem.AcceptedQuantity,
                                acceptQty: elem.CallItemType !== null ? elem.RWAcceptedQuantity === null || elem.RWAcceptedQuantity === null ? 0 : elem.RWAcceptedQuantity : elem.AcceptedQuantity === null || elem.AcceptedQuantity === '' ? 0 : elem.AcceptedQuantity,
                                CallItemType: elem.CallItemType,
                                // CallID: elem.CallID,
                                // IsActive: elem.IsActive,
                                InspectionCallItemId: elem.InspectionCallItemId,
                                ParentCallId: elem.CallItemType !== null ? elem.InspectionCallItemId : elem.ParentCallId,
                            }
                        )
                    }
                }
                callItems[index].PurchaseOrderLineList.push(
                    {
                        id: element.PurchaseOrderLineId,
                        name: element.POLineItemSAPCode,
                    }
                )
            }
            return element
        })

        this.setState({ callItems: callItems })
    }

    handleInspectionTypeChange = (e, index) => {
        let callItems = [...this.state.callItems]
        callItems[index].inspectionType = e.target.value

        this.setState({ callItems })
    }

    handlePoLineChange = async (e, index) => {
        let callItems = [...this.state.callItems]
        let exist = callItems.find((item, i) => i !== index && item.PurchaseOrderLineId === e.target.value)
        if (exist) {
            callItems[index].PurchaseOrderLineId = ''
            callItems[index].stagesList = []
            this.setState({ callItems: callItems })
            swal('The same Po Line Item already selected', { icon: "error" })
            return false;
        }
        callItems[index].PurchaseOrderLineId = e.target.value

        let lineItem = await this.props.vendorPOsWithStages.vendorPOsWithStages.polineItems.find((element) => element.PurchaseOrderLineId === parseInt(callItems[index].PurchaseOrderLineId))

        console.log(lineItem, 'lineItem')

        callItems[index].stagesList = []
        if (lineItem) {
            lineItem.stageItems.map((item, i) => {
                callItems[index].stagesList.push(
                    {
                        id: item[`QaTemplateStageID`],
                        name: item[`StageName`],
                        totalQuantity: item.CallItemType !== null ? item.TotalQuantity : item.POLineItemQuantity,
                        pendingQuantity: item.CallItemType !== null ? item.TotalQuantity - item.OfferedQuantity : item.POLineItemQuantity - item.OfferedQuantity,
                        offeredQuantity: 0,
                        prevOfferedQuantity: item.OfferedQuantity,
                        AcceptedQuantity: item.AcceptedQuantity,
                        acceptQty: item.CallItemType !== null ? item.RWAcceptedQuantity === null || item.RWAcceptedQuantity === null ? 0 : item.RWAcceptedQuantity : item.AcceptedQuantity === null || item.AcceptedQuantity === '' ? 0 : item.AcceptedQuantity,
                        // CallID: item.CallID,
                        // IsActive: item.IsActive,
                        InspectionCallItemId: item.InspectionCallItemId,
                        ParentCallId: item.CallItemType !== null ? item.InspectionCallItemId : item.ParentCallId,
                        CallItemType: item.CallItemType,
                    }
                )
                // if (item.CallItemType !== null) {
                //     callItems[index].stagesList[i].totalQuantity = item.TotalQuantity
                //     callItems[index].stagesList[i].AcceptedQuantity = item.OfferedQuantity === null ? true : false
                //     callItems[index].stagesList[i].pendingQuantity = item.TotalQuantity - item.OfferedQuantity
                // }
                return item
            })
        }

        this.setState({ callItems: callItems })
    }

    addCallItem = async () => {
        let callItems = [...this.state.callItems]
        let PurchaseOrderList = [];
        this.state.formattedData.map((item) => {
            if (!PurchaseOrderList.find((e) => e.value === item.POSAPId)) {
                PurchaseOrderList.push({
                    label: item.POSAPId,
                    value: item.POSAPId,
                })
            }
            return item
        })
        console.log(PurchaseOrderList, 'PurchaseOrderList')
        callItems.push(
            {
                PurchaseOrderId: '',
                PurchaseOrderItem: '',
                PurchaseOrderList: PurchaseOrderList,
                PurchaseOrderLineList: [],
                PurchaseOrderLineId: '',
                stagesList: [],
                stages: [],
                finalLineItemsList: [],
                finalLineItems: [],
                checkedAll: false,
                inspectionTypes: [
                    {
                        id: 0, name: "Stage",
                    },
                    {
                        id: 1, name: "Final",
                    },
                ],
                inspectionType: 0,
            }
        )

        this.setState({ callItems: callItems })
    }

    removeCallItem = (index) => {
        let callItems = [...this.state.callItems]
        callItems.splice(index, 1)

        this.setState({ callItems: callItems })

        console.log(callItems)
    }

    handleCheckedAll = async (index, inspectionType = '') => {
        let callItems = [...this.state.callItems]

        var checkedAll = !callItems[index].checkedAll

        callItems[index].checkedAll = checkedAll
        if (inspectionType !== '') {
            await callItems[index].finalLineItemsList.map((stage, Index) => {
                var flag_index = callItems[index].finalLineItems.includes(Index)
                if (checkedAll) {
                    if (!flag_index && stage.pendingQuantity !== 0) {
                        callItems[index].finalLineItems.push(Index)
                    }
                } else {
                    if (flag_index) {
                        callItems[index].finalLineItems = callItems[index].finalLineItems.filter((item) => item !== Index)
                    }
                }
                return stage
            })
        } else {
            await callItems[index].stagesList.map((stage, Index) => {
                var flag_index = callItems[index].stages.includes(Index)
                if (checkedAll) {
                    if (!flag_index && stage.pendingQuantity !== 0) {
                        callItems[index].stages.push(Index)
                    }
                } else {
                    if (flag_index) {
                        callItems[index].stages = callItems[index].stages.filter((item) => item !== Index)
                    }
                }
                return stage
            })
        }
        console.log(callItems, 'callItemsFinalStage')

        this.setState({ callItems: callItems })
    }

    handleCheck = async (e, index, Index, inspectionType = '') => {
        let callItems = [...this.state.callItems]

        var flag_index = callItems[index].stages.includes(Index)
        var checkedAll = callItems[index].checkedAll
        if (inspectionType !== '') {
            flag_index = callItems[index].finalLineItems.includes(Index)
            if (flag_index) {
                if (checkedAll) {
                    callItems[index].checkedAll = !checkedAll
                }
                callItems[index].finalLineItems = callItems[index].finalLineItems.filter((item) => item !== Index)
            } else {
                callItems[index].finalLineItems.push(Index)
            }
        } else {
            if (flag_index) {
                if (checkedAll) {
                    callItems[index].checkedAll = !checkedAll
                }
                callItems[index].stages = callItems[index].stages.filter((item) => item !== Index)
            } else {
                callItems[index].stages.push(Index)
            }
        }
        this.setState({ callItems: callItems })
    }

    // ? func to add extra fields required for requesting inspection
    formatData = async (arrData) => {

        let temp_arr = arrData ? [...arrData] : []
        let arr = []

        let callItems = [...this.state.callItems]

        await temp_arr.map(el => {

            let obj = {
                location: el.VendorLocation,
                POLineItemSAPCode: el.POLineItemSAPCode,
                POSAPId: el.POSAPId,
                PurchaseOrderId: el.PurchaseOrderId,
                PurchaseOrderItem: { label: el.PurchaseOrderId, value: el.PurchaseOrderId },
                PurchaseOrderLineId: el.PurchaseOrderLineId,
                vendorId: AuthHandlerInstance.getUserPayLoad().userId,
            }
            arr.push(obj)
            return el
        })

        arr.map((item) => {
            if (!callItems[0].PurchaseOrderList.find((e) => e.value === item.POSAPId)) {
                callItems[0].PurchaseOrderList.push({
                    label: item.POSAPId,
                    value: item.POSAPId,
                })
            }
            return item
        })



        console.log("formatted data ", arr, temp_arr)

        this.setState({ formattedData: arr, callItems: callItems })

    }

    // ? function for requesting inspection
    requestInspection = async () => {
        const selectedDate = new Date(this.state.vendorProposedDate);
        const currentDate = new Date();
        let UserId = AuthHandlerInstance.getUserID()
        const { isRequestingInspection } = this.state
        this.setState({ isRequestingInspection: true })
        let callItems = [...this.state.callItems]
        console.log('callItems', callItems)
        let errorMessage = '';

        // Todo: check for blank entries and give alert with PO - LineItem to warn
        if (callItems.length < 1) {
            swal("Please select a valid inspection for request", { icon: "error" });
        }

        if (this.state.vendorProposedDate === '' || selectedDate.setHours(0, 0, 0, 0) < currentDate.setHours(0, 0, 0, 0)) {
            swal('Request has been required a valid proposed date of inspection', { icon: "error" })
            this.setState({ isRequestingInspection: false })
            return false;
        }

        for (let j = 0; j < callItems.length; j++) {
            let lineItem = await this.props.vendorPOsWithStages.vendorPOsWithStages.polineItems.find((element) => element.PurchaseOrderLineId === parseInt(callItems[j].PurchaseOrderLineId))
            if (callItems[j].PurchaseOrderId === '') {
                errorMessage = `Please select PO`;
                this.setState({ isRequestingInspection: false })
                break;
            }
            if (parseInt(callItems[j].inspectionType) === 1 && callItems[j].finalLineItems.length < 1) {
                errorMessage = `Please select PO Line Item`;
                break;
            }
            // if (callItems[j].PurchaseOrderLineId === '' && parseInt(callItems[j].inspectionType) === 0) {
            //     errorMessage = `Please select PO Line Item`;
            //     break;
            // }
            if (callItems[j].stages.length < 1 && parseInt(callItems[j].inspectionType) === 0) {

                errorMessage = `Please select valid Stages to Inspect for PO Line Item ${lineItem['POLineItemSAPCode']}`;
                break;
            }
            if (callItems[j].stages.length > 0 && parseInt(callItems[j].inspectionType) === 0) {
                for (let k = 0; k < callItems[j].stages.length; k++) {
                    if (callItems[j].stagesList[callItems[j].stages[k]].offeredQuantity === '' || parseFloat(callItems[j].stagesList[callItems[j].stages[k]].offeredQuantity) <= 0) {
                        errorMessage = `Please enter valid Offered quantity to Inspect for stage ${callItems[j].stagesList[callItems[j].stages[k]].name} of PO Line Item ${lineItem['POLineItemSAPCode']}`;
                        break;
                    }
                }
            } else {
                for (let k = 0; k < callItems[j].finalLineItems.length; k++) {
                    if (callItems[j].finalLineItemsList[callItems[j].finalLineItems[k]].offeredQuantity === '' || parseFloat(callItems[j].finalLineItemsList[callItems[j].finalLineItems[k]].offeredQuantity) <= 0) {
                        errorMessage = `Please enter valid Offered quantity to Inspect for PO Line Item ${callItems[j].finalLineItemsList[callItems[j].finalLineItems[k]]['POLineItemSAPCode']}`;
                        break;
                    }
                }
            }
        }
        // console.log(callItems, 'callItems')

        if (errorMessage !== '') {
            swal(errorMessage, { icon: 'error' })
            this.setState({ isRequestingInspection: false })
            return false;
        }
        // return false;
        let inspectionCall = {};
        inspectionCall.vendorProposedDate = this.state.vendorProposedDate
        inspectionCall.location = this.state.location
        inspectionCall.vendorId = AuthHandlerInstance.getUserPayLoad().userId
        inspectionCall.inspectioncallno = `I${callItems[0].PurchaseOrderId}${callItems[0].PurchaseOrderLineId}P`

        let paramArray = [];
        for (let i = 0; i < callItems.length; i++) {
            if (parseInt(callItems[i].inspectionType) === 0) {
                for (let n = 0; n < callItems[i].stages.length; n++) {
                    paramArray.push({
                        UserId: UserId,
                        POSAPId: callItems[i].PurchaseOrderId,
                        PurchaseOrderLineId: callItems[i].stagesList[callItems[i].stages[n]].id,
                        QaTemplateStageID: 1,
                        OfferedQuantity: callItems[i].stagesList[callItems[i].stages[n]].offeredQuantity,
                        TotalQuantity: callItems[i].stagesList[callItems[i].stages[n]].totalQuantity,
                        InspectionCallItemId: callItems[i].stagesList[callItems[i].stages[n]].CallItemType !== null ? callItems[i].stagesList[callItems[i].stages[n]].InspectionCallItemId : 0,
                        ParentCallId: callItems[i].stagesList[callItems[i].stages[n]].CallItemType !== null && callItems[i].stagesList[callItems[i].stages[n]].prevOfferedQuantity !== null ? callItems[i].stagesList[callItems[i].stages[n]].InspectionCallItemId : callItems[i].stagesList[callItems[i].stages[n]].ParentCallId,
                        CallItemType: callItems[i].stagesList[callItems[i].stages[n]].CallItemType,
                    })
                }
            } else {
                for (let n = 0; n < callItems[i].finalLineItems.length; n++) {
                    paramArray.push({
                        UserId: UserId,
                        POSAPId: callItems[i].PurchaseOrderId,
                        PurchaseOrderLineId: callItems[i].finalLineItemsList[callItems[i].finalLineItems[n]].id,
                        QaTemplateStageID: 0,
                        OfferedQuantity: callItems[i].finalLineItemsList[callItems[i].finalLineItems[n]].offeredQuantity,
                        TotalQuantity: callItems[i].finalLineItemsList[callItems[i].finalLineItems[n]].totalQuantity,
                        InspectionCallItemId: callItems[i].finalLineItemsList[callItems[i].finalLineItems[n]].CallItemType !== null ? callItems[i].finalLineItemsList[callItems[i].finalLineItems[n]].InspectionCallItemId : 0,
                        ParentCallId: callItems[i].finalLineItemsList[callItems[i].finalLineItems[n]].CallItemType !== null && callItems[i].finalLineItemsList[callItems[i].finalLineItems[n]].prevOfferedQuantity !== null ? callItems[i].finalLineItemsList[callItems[i].finalLineItems[n]].InspectionCallItemId : callItems[i].finalLineItemsList[callItems[i].finalLineItems[n]].ParentCallId,
                        CallItemType: callItems[i].finalLineItemsList[callItems[i].finalLineItems[n]].CallItemType,
                    })
                }
            }
        }
        inspectionCall.callItems = paramArray
        console.log("DDDDDDDD", inspectionCall);

        if (!isRequestingInspection) {
            this.setState({ isRequestingInspection: true })
            try {
                await this.props.posNewtRequestInspection(inspectionCall)
            } catch (error) {
                console.error('Error requesting inspection:', error)
            } finally {
                this.setState({ isRequestingInspection: false })
            }
        }

        let newCallItems = [
            {
                PurchaseOrderId: '',
                PurchaseOrderItem: '',
                PurchaseOrderList: [],
                PurchaseOrderLineList: [],
                PurchaseOrderLineId: '',
                stagesList: [],
                stages: [],
                finalLineItemsList: [],
                finalLineItems: [],
                checkedAll: false,
                inspectionTypes: [
                    {
                        id: 0, name: "Stage",
                    },
                    {
                        id: 1, name: "Final",
                    },
                ],
                inspectionType: 0,
            }
        ];
        await this.setState({ callItems: newCallItems })
        this.storeData()

    }

    validateInput = (arrayVal) => {
        let errorMessage = '';
        for (let j = 0; j < arrayVal.length; j++) {
            console.log(arrayVal[j]);
            if (!('vendorProposedDate' in arrayVal[j]) || ('vendorProposedDate' in arrayVal[j] && arrayVal[j]['vendorProposedDate'] === "")) {
                errorMessage = `PO Number ${arrayVal[j]['POSAPId']} has been required a valid proposed date of inspection`;
                break;
                //  vendorProposedDate, qaTemplateStageId, inspectionQuantity
            } else if (!('qaTemplateStageId' in arrayVal[j]) || ('qaTemplateStageId' in arrayVal[j] && arrayVal[j]['qaTemplateStageId'] === "")) {
                errorMessage = `Please select valid Stages to Inspect for PO Number ${arrayVal[j]['POSAPId']}`;
                break;
            } else if (!('inspectionQuantity' in arrayVal[j]) || ('inspectionQuantity' in arrayVal[j] && arrayVal[j]['inspectionQuantity'] === "")) {
                errorMessage = `Please enter a valid inspection quantity for PO Number ${arrayVal[j]['POSAPId']}`;
                break;
            }
        }

        if (errorMessage !== '') {
            swal(errorMessage, { icon: "error" })
            return false;
        }

        return true;
    }

    render() {
        return (
            <div className="Container-fluid p-4">

                <div className="row pr-8" >
                    <div className="col-md-4 header ">
                        {this.state.supplierName}
                    </div>
                    <div className="col-md-4 ">
                        <button className="btn2 btn-sms1 mt-2 float-right" type="button" disabled={this.state.isRequestingInspection} onClick={this.requestInspection} > Request Inspection </button>
                    </div>
                </div>
                <div className="border border-dark mt-2 mr-2 p-2">
                    <div className="row pr-4 pl-2">
                        <div className="col ">
                            <div className="row">
                                <div className="col">
                                    <b>Proposed Date of Inspection: </b>
                                </div>
                                <div className="col">
                                    <Form.Control type="date" onChange={(e) => { this.handleDate(e) }}
                                        onBlur={(e) => { this.checkInspectionDate(e) }} id="proposedDate-datepicker" name="proposedDate" min={new Date().toISOString().split("T")[0]} placeholder="Proposed Date" />
                                </div>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="row">
                                <div className="col">
                                    <b>Location:  </b>
                                </div>
                                <div className="col">
                                    <Form.Control type="text" placeholder="Enter Location" onChange={(e) => { this.handleLocation(e) }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.callItems.map((item, index) => {
                        return (
                            <>
                                <div className="row mt-2 pr-4 pl-2">
                                    <div className="col ">
                                        <div className="row">
                                            <div className="col">
                                                <b>Inspection Type:  </b>
                                            </div>
                                            <div className="col">
                                                <DropdownFlat defaultopt="Select Type" data={item.inspectionTypes} selectedValue={item.inspectionType} actions={(e) => { this.handleInspectionTypeChange(e, index) }} keyObjName={"id"} valueObjName={"name"} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col ">
                                        <div className="row">
                                            <div className="col">
                                                <b>PO:  </b>
                                            </div>
                                            <div className="col">
                                                <Select defaultopt="Select PO" options={item.PurchaseOrderList} value={item.PurchaseOrderItem} onChange={(e) => { this.handlePoChange(e, index) }} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* {parseInt(item.inspectionType) === 0 ?
                                        <div className="col ">
                                            <div className="row">
                                                <div className="col">
                                                    <b>PO Line Item:  </b>
                                                </div>
                                                <div className="col">
                                                    <DropdownFlat defaultopt="Select PO Line Item" data={item.PurchaseOrderLineList} selectedValue={item.PurchaseOrderLineId} actions={(e) => { this.handlePoLineChange(e, index) }} keyObjName={"id"} valueObjName={"name"} />
                                                </div>
                                            </div>
                                        </div>
                                        : null
                                    } */}
                                </div>
                                {item.finalLineItemsList.length > 0 || item.stagesList.length > 0 ?
                                    <div className="row mt-2 pr-4 pl-4">
                                        <div className="col">
                                            {parseInt(item.inspectionType) === 0 && item.stagesList.length > 0 ?
                                                <>
                                                    <div className="row  headerbar ">
                                                        <div className="col-md-1 pt-2 pb-2 checkboxheaderbar borderheaderbar ">

                                                            <input
                                                                type="checkbox" onChange={() => this.handleCheckedAll(index)} checked={item.checkedAll} />
                                                        </div>
                                                        <div className="col-md-3 pt-2 pb-2 borderheaderbar">Item No.</div>
                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar">Total QTY</div>
                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar">Accepted Quantity</div>
                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar">Pending QTY</div>
                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar">Offered Quantity</div>
                                                    </div>
                                                    {item.stagesList.map((stage, Index) => {
                                                        return (
                                                            <div className={Index % 2 === 0 ? 'row border ' : 'row  background '}>
                                                                <div className="col-md-1 pt-2 pb-2 borderheaderbar">
                                                                    {(stage.pendingQuantity !== 0) ? (<input
                                                                        type="checkbox" checked={item.stages.includes(Index) ? true : false} onChange={(e) => { this.handleCheck(e, index, Index) }}
                                                                    />) : (<input
                                                                        type="checkbox" disabled checked={item.stages.includes(Index) ? true : false} onChange={(e) => { this.handleCheck(e, index, Index) }}
                                                                    />)}

                                                                </div>
                                                                <div className="col-md-3 pt-2 pb-2 borderheaderbar"> {stage.CallItemType === 'RW' ? (<b>Rework</b>) : stage.CallItemType === 'RV' ? (<b>Revisit</b>) : stage.CallItemType === 'RI' ? (<b>Incomplete Complete</b>) : stage.CallItemType === 'RC' ? (<b>Rework Compliance</b>) : stage.CallItemType === 'RJ' ? (<b>Rejected</b>) : ''} {stage.POLineItemSAPCode}</div>
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">{stage.totalQuantity}</div>
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">{stage.acceptQty}</div>
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">{stage.pendingQuantity}</div>
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">
                                                                    <Form.Control type="number" placeholder="Enter quantity" value={stage.offeredQuantity} onChange={(e) => { this.handleIQuantityInput(e, index, Index, stage.pendingQuantity, item.OrderUnit) }} />
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </>

                                                :
                                                <>
                                                    <div className="row  headerbar ">
                                                        <div className="col-md-1 pt-2 pb-2 checkboxheaderbar borderheaderbar ">

                                                            <input
                                                                type="checkbox" onChange={() => this.handleCheckedAll(index, 'final')} checked={item.checkedAll} />
                                                        </div>
                                                        <div className="col-md-3 pt-2 pb-2 borderheaderbar">Item No.</div>
                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar">Total QTY</div>
                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar">Accepted Quantity</div>
                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar">Pending QTY</div>
                                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar">Offered Quantity</div>
                                                    </div>
                                                    {item.finalLineItemsList.map((final, Index) => {
                                                        return (
                                                            <div className={Index % 2 === 0 ? 'row border ' : 'row  background '}>
                                                                <div className="col-md-1 pt-2 pb-2 borderheaderbar">
                                                                    {(final.pendingQuantity !== 0) ? (<input
                                                                        type="checkbox" checked={item.finalLineItems.includes(Index) ? true : false} onChange={(e) => { this.handleCheck(e, index, Index, 'final') }}
                                                                    />) : (<input
                                                                        type="checkbox" disabled checked={item.finalLineItems.includes(Index) ? true : false} onChange={(e) => { this.handleCheck(e, index, Index, 'final') }}
                                                                    />)}

                                                                </div>
                                                                <div className="col-md-3 pt-2 pb-2 borderheaderbar"> {final.CallItemType === 'RW' ? (<b>Rework</b>) : final.CallItemType === 'RV' ? (<b>Revisit</b>) : final.CallItemType === 'RI' ? (<b>Incomplete Complete</b>) : final.CallItemType === 'RC' ? (<b>Rework Compliance</b>) : final.CallItemType === 'RJ' ? (<b>Rejected</b>) : ''} {final.POLineItemSAPCode}</div>
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">{final.totalQuantity}</div>
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">{final.acceptQty}</div>
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">{final.pendingQuantity}</div>
                                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">
                                                                    <Form.Control type="number" placeholder="Enter quantity" value={final.offeredQuantity} onChange={(e) => { this.handleIQuantityInput(e, index, Index, final.pendingQuantity, item.OrderUnit, 'final') }} />
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </>
                                            }
                                        </div>
                                    </div>
                                    :
                                    ""
                                }
                                <div className="row mt-2 pr-4 pl-4">
                                    <div className="col">
                                        {0 === index ?
                                            <button className="btn2 btn-sms1 mt-2 float-right" type="button" onClick={this.addCallItem} > Add More </button>
                                            :
                                            <button className="btn2 btn-sms1 mt-2 float-right" type="button" onClick={() => this.removeCallItem(index)} > Remove </button>
                                        }
                                    </div>
                                </div>
                            </>
                        )
                    })}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({ supplier: state.supplier, vendorPOsWithStages: state.vendorReducer })
export default connect(mapStateToProps, { getSupplierPOs, postRequestInspection, getVendorPODetailsWithStages, posNewtRequestInspection })(Dashboard)